import { InjectionToken } from '@angular/core';

import { ConsentLevels } from './cookie-consent.model';

export const CONSENT_DATA = new InjectionToken<ConsentLevels>('CONSENT_DATA');

export const LAYOUT_DATA = new InjectionToken<string>('LAYOUT_DATA');

export const CALLBACK_FNC = new InjectionToken<(ConsentLevels) => void>('CALLBACK_FNC');
